import React, { FC, useState, useEffect, MouseEvent } from "react";
import {
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  IconButton,
  Paper,
  Tooltip,
} from "@mui/material";
import { Close, Info } from "@mui/icons-material";
import ArrowPopper from "components/app/ArrowPopper";
import { GridReadyEvent } from "ag-grid-community";
import { TransformlabelValueItem, TransformTooltips } from "./components/TransformlabelValueItem";
import styles from "./ActiveFilter.module.scss";

interface GirdViewFunction {
  gridEvent?: GridReadyEvent;
  ignoreColumns: Array<string>;
}

interface UncontrolledDialog extends GirdViewFunction {
  controlled?: false;
}
interface ControlledDialog extends GirdViewFunction {
  controlled: true;
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

type DialogProps = UncontrolledDialog | ControlledDialog;

const ActiveFilter: FC<DialogProps> = (props) => {
  const { gridEvent, ignoreColumns } = props as DialogProps;
  const [filterList, setFilterList] = useState<any[]>([]);
  const [localAnchorEl, setLocalAnchorEl] = useState<HTMLElement | null>(null);
  const isControlled = Boolean((props as ControlledDialog).controlled);
  const activeAnchorEl: HTMLElement | null = isControlled
    ? (props as ControlledDialog).anchorEl
    : localAnchorEl;
  const activeSetAnchorEl: (el: HTMLElement | null) => void = isControlled
    ? (props as ControlledDialog).setAnchorEl
    : setLocalAnchorEl;

  useEffect(() => {
    initFilerActive();
    gridEvent?.api?.addEventListener("filterChanged", () => {
      initFilerActive();
    });
  }, [gridEvent]);

  const getHeaderName = ({ key: colId, value }: { key: string; value: { filter: string } }) => {
    if (colId === "externalEPFilter")
      return value.filter.split("+")[1] === "all"
        ? "Renewal Assessment All Accounts"
        : "Renewal Assessment Due";
    return gridEvent?.api.getColumnDef(colId)?.headerName ?? colId;
  };

  const initFilerActive = () => {
    const filterModel = gridEvent?.api?.getFilterModel();
    if (filterModel && Object.keys(filterModel).length) {
      const extra = filterModel
        ? Object.fromEntries(
            Object.entries(filterModel).filter(([key]) => !ignoreColumns.includes(key))
          )
        : {};
      const list = Object.entries(extra).map(([key, value]) => ({
        key,
        value,
      }));
      setFilterList(list || []);
    }
  };
  const handleDelete = (e: any, val: string) => {
    // e.stopPropagation();
    const filterModel = gridEvent?.api?.getFilterModel();
    // delete filter
    if (!!filterModel) {
      delete filterModel[val];
    }
    gridEvent?.api?.setFilterModel({
      ...filterModel,
    });
    // delelete from list
    setFilterList(filterList.filter((x) => x !== val));
    if (!filterList.length) {
      // onClose();
      setFilterList([]);
    }
    setFilterList(filterList);
  };
  const openPop = (event: MouseEvent<HTMLParagraphElement>) => {
    event.stopPropagation();
    activeSetAnchorEl(event?.currentTarget);
  };
  const closePop = () => {
    activeSetAnchorEl(null);
  };

  return (
    <>
      {filterList?.length ? (
        <p
          className={styles.title}
          onClick={openPop}
        >
          <Info
            htmlColor="#00A0D1"
            fontSize="inherit"
            style={{ marginRight: "6px" }}
          />
          {filterList?.length} Filter(s) Active
        </p>
      ) : null}
      <ArrowPopper
        disableStyle={true}
        open={Boolean(activeAnchorEl)}
        anchorEl={activeAnchorEl}
        placement="bottom-end"
        handleClose={closePop}
        disableArrow={true}
      >
        <Paper>
          <List
            dense
            className={styles.list}
          >
            {filterList?.map((item: any, idx: number) => {
              return (
                <div key={item.key}>
                  <ListItem
                    key={item.key}
                    button
                  >
                    <Tooltip title={TransformTooltips({ item })}>
                      <ListItemText
                        classes={{ primary: styles.MuiListItemTextPrimary }}
                        primary={<span className={styles.filterLabel}>{getHeaderName(item)}:</span>}
                        secondary={
                          <span className={styles.filterValue}>
                            <TransformlabelValueItem
                              item={item}
                              filterList={filterList}
                            />
                          </span>
                        }
                      />
                    </Tooltip>
                    <ListItemSecondaryAction onClick={(e) => handleDelete(e, item.key)}>
                      <IconButton
                        size="small"
                        edge="end"
                      >
                        <Close
                          fontSize="small"
                          color="secondary"
                        />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {filterList?.length > 1 && idx < filterList?.length - 1 ? <Divider /> : null}
                </div>
              );
            })}
          </List>
        </Paper>
      </ArrowPopper>
    </>
  );
};

export default ActiveFilter;
